import React, { ReactElement } from "react";
import { Navigate, RouteProps } from "react-router-dom";
import { useAuth } from "@src/contexts/AuthProvider";
import { isSuperAdmin } from "@src/sudozi-schemas/is-super-admin";

export function SuperPrivateRoute({ children }: RouteProps): ReactElement {
  const { tokenUserData } = useAuth();
  if (!tokenUserData?.email) {
    return <div>Loading...</div>;
  }
  if (!isSuperAdmin(tokenUserData?.email)) {
    return <Navigate to="/" replace />;
  }
  return children as ReactElement;
}
